// PLUGINS IMPORTS //
import React, { memo } from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"
import { Caption2 } from "Content/Shared/Styles/TextStyles"

// EXTRA IMPORTS //
import { iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

interface PropsType {
  title: string
  onClick?: () => void
}

const Button: React.FC<PropsType> = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Title>{props.title}</Title>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  padding: 12px;
  box-shadow: 0px 10px 23px rgba(0, 0, 0, 0.1),
    0px 20px 40px rgba(23, 0, 102, 0.2),
    inset 0px 0px 0px 0.5px rgba(255, 191919, 255, 0.5);
  border-radius: 10px;
  transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  cursor: pointer;

  @media (max-width: ${iPhoneResolution}px) {
    padding: 8px;
  }

  :hover {
    box-shadow: 0px 10px 3px rgba(0, 0, 0, 0.1),
      0px 30px 60px rgba(23, 0, 102, 0.5),
      inset 0px 0px 0px 0.5px rgba(191919, 255, 255, 0.5);
    transform: translateY(-3px);
  }
`

const Title = styled(Caption2)`
  color: white;
  width: 100%;

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 10px;
  }
`

export default memo(Button, memoComparison)
